/** For tests and for platforms without persistent storage. */
export class MemoryVaultStore {
    items = new Map();
    async get(network) {
        return structuredClone(this.items.get(network) ?? null);
    }
    async put(vault) {
        this.items.set(vault.network, structuredClone(vault));
    }
    async delete(network) {
        this.items.delete(network);
    }
    restores = new Map();
    async getRestore(network) {
        return structuredClone(this.restores.get(network) ?? null);
    }
    async putRestore(restore) {
        this.restores.set(restore.network, structuredClone(restore));
    }
    async deleteRestore(network) {
        this.restores.delete(network);
    }
}
const DB_NAME = "custos-vault";
const STORE = "vaults";
/** Browser IndexedDB. Each vault is stored under its network name. */
export class IndexedDbVaultStore {
    factory;
    dbPromise = null;
    constructor(factory = indexedDB) {
        this.factory = factory;
    }
    open() {
        this.dbPromise ??= new Promise((resolve, reject) => {
            const request = this.factory.open(DB_NAME, 1);
            request.onupgradeneeded = () => request.result.createObjectStore(STORE);
            request.onsuccess = () => resolve(request.result);
            request.onerror = () => reject(request.error ?? new Error("Could not open the vault storage"));
            request.onblocked = () => reject(new Error("Vault storage is busy in another tab — close it and retry"));
        });
        this.dbPromise.catch(() => {
            this.dbPromise = null;
        });
        return this.dbPromise;
    }
    async run(mode, action) {
        const db = await this.open();
        return new Promise((resolve, reject) => {
            const tx = db.transaction(STORE, mode);
            const request = action(tx.objectStore(STORE));
            tx.oncomplete = () => resolve(request.result);
            tx.onerror = () => reject(tx.error ?? new Error("Vault storage error"));
            tx.onabort = () => reject(tx.error ?? new Error("Vault storage error"));
        });
    }
    async get(network) {
        const value = await this.run("readonly", (s) => s.get(network));
        return value ?? null;
    }
    async put(vault) {
        await this.run("readwrite", (s) => s.put(vault, vault.network));
    }
    async delete(network) {
        await this.run("readwrite", (s) => s.delete(network));
    }
    async getRestore(network) {
        const value = await this.run("readonly", (s) => s.get(`restore:${network}`));
        return value ?? null;
    }
    async putRestore(restore) {
        await this.run("readwrite", (s) => s.put(restore, `restore:${restore.network}`));
    }
    async deleteRestore(network) {
        await this.run("readwrite", (s) => s.delete(`restore:${network}`));
    }
}
//# sourceMappingURL=store.js.map